'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Box = require('../../../../../../../../common/components/layout/Box/Box.js');
var ItemCard_module = require('./ItemCard.module.css.js');
var ProductThumbnail = require('@narvar/nth-block-product-thumbnail');
var Thumbnail = require('@narvar/nth-bit-thumbnail');
var ClaimDetailsDescription = require('../../../../components/ClaimDetailsDescription.js');
var ItemCardItemDetails = require('./ItemCardItemDetails.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ProductThumbnail__default = /*#__PURE__*/_interopDefaultLegacy(ProductThumbnail);
var Thumbnail__default = /*#__PURE__*/_interopDefaultLegacy(Thumbnail);

const ItemClaimTypeItemCard = _ref => {
  var _item$photos;
  let {
    item
  } = _ref;
  const {
    claimsClaimDetailsLabelCustomerComments
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    as: "li",
    className: ItemCard_module["default"].item,
    gap: 4,
    key: item.sku
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, /*#__PURE__*/React__default["default"].createElement(ProductThumbnail__default["default"], {
    productInfo: {
      imageUrl: item.itemImage,
      name: item === null || item === void 0 ? void 0 : item.name
    },
    s: {
      margin: 0
    }
  }), /*#__PURE__*/React__default["default"].createElement(ItemCardItemDetails["default"], {
    item: item
  })), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionContainer, {
    style: {
      alignContent: 'start'
    }
  }, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsLabelCustomerComments,
    value: item.comments ? item.comments : 'Customer did not include any comment'
  }), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: "Customer photos (click to view full image)",
    value: (_item$photos = item.photos) !== null && _item$photos !== void 0 && _item$photos.length ? /*#__PURE__*/React__default["default"].createElement(Box["default"], {
      as: "ul",
      display: "flex",
      gap: 2,
      style: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: 0,
        margin: 0
      }
    }, item.photos.map((photo, i) => photo.url && /*#__PURE__*/React__default["default"].createElement("li", {
      key: i
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      target: "_blank",
      rel: "noreferrer",
      href: photo.url
    }, /*#__PURE__*/React__default["default"].createElement(Thumbnail__default["default"], {
      alt: `Customer claim photo ${i + 1}`,
      src: photo.url,
      key: photo.url
    }))))) : 'No photos included'
  })));
};
var ItemClaimTypeItemCard$1 = nthHookTranslations.withTranslationsProvider(ItemClaimTypeItemCard, {
  translationKeys: ['claimsClaimDetailsLabelCustomerComments']
});

exports["default"] = ItemClaimTypeItemCard$1;
